import React from "react";
import { Card, CardBody, Table, Progress } from "reactstrap";
import { useTranslation } from "react-i18next";

const DoctorPerformanceTable = ({ doctors = [] }) => {
  const { t } = useTranslation();

  return (
    <Card className="border-0 shadow-sm mb-4 h-100">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
          <div className="d-flex align-items-center">
            <div className="avatar-xs me-2">
              <span className="avatar-title rounded bg-soft-success text-success font-size-16">
                <i className="bx bx-user-check" />
              </span>
            </div>
            <div>
              <h5 className="card-title mb-0 font-size-15 fw-bold">
                {t("Doctor & Specialist Performance")}
              </h5>
              <div className="text-muted font-size-11">
                {t("Clinical cases attended and completion throughput")}
              </div>
            </div>
          </div>
        </div>

        {doctors.length === 0 ? (
          <div className="text-center py-4 text-muted bg-light rounded">
            <i className="bx bx-user-x font-size-24 text-secondary mb-1 d-block" />
            <div className="font-size-13 fw-medium">{t("No doctor records found")}</div>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover className="align-middle table-nowrap mb-0 font-size-12">
              <thead className="table-light text-muted">
                <tr>
                  <th>{t("Doctor / Specialist")}</th>
                  <th className="text-center">{t("Assigned")}</th>
                  <th className="text-center">{t("Completed")}</th>
                  <th>{t("Throughput")}</th>
                </tr>
              </thead>
              <tbody>
                {doctors.map((doc) => {
                  const rate = doc.completion_rate || 0;

                  return (
                    <tr key={doc.id || doc.code}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div
                            className="avatar-xs rounded-circle me-2 d-flex align-items-center justify-content-center text-white font-size-11 fw-bold"
                            style={{ backgroundColor: doc.color_code || "#556ee6" }}
                          >
                            {doc.name ? doc.name.charAt(0).toUpperCase() : "D"}
                          </div>
                          <div>
                            <div className="fw-semibold text-dark font-size-13">
                              Dr. {doc.name}
                            </div>
                            <div className="text-muted font-size-11">
                              {t("Code")}: {doc.code}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="text-center fw-medium font-size-13">
                        {doc.total_appointments}
                      </td>
                      <td className="text-center font-size-13 text-success fw-bold">
                        {doc.completed_cases}
                      </td>
                      <td style={{ minWidth: "120px" }}>
                        <div className="d-flex align-items-center gap-2">
                          <div className="flex-grow-1">
                            <Progress
                              value={rate}
                              color={rate >= 80 ? "success" : rate >= 50 ? "warning" : "primary"}
                              size="sm"
                              className="rounded"
                            />
                          </div>
                          <span className="font-size-11 text-muted fw-semibold">{rate}%</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default DoctorPerformanceTable;
